import React from "react";

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-6">
        Privacy Policy
      </h1>

      <div className="prose dark:prose-invert max-w-none">
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-3">
            Data Collection
          </h2>
          <p className="text-gray-600 dark:text-gray-300">
            devagile.tools does not collect, store, or process any personal
            data. All tool usage happens locally in your browser.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-3">
            Cookies
          </h2>
          <p className="text-gray-600 dark:text-gray-300">
            We use only essential cookies for functionality (like team member
            storage and dark mode preference). No tracking cookies are used.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-3">
            Third-Party Services
          </h2>
          <p className="text-gray-600 dark:text-gray-300">
            This site uses Google AdSense for advertising. Please refer to
            Google's privacy policy for information on their data practices.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-3">
            Contact
          </h2>
          <p className="text-gray-600 dark:text-gray-300">
            If you have any questions about this privacy policy, please reach
            out through our support channels.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
